import styled from 'styled-components';

export const primaryColor = '#437EFB';
export const secondaryColor = '#6366F1'; 
export const sidebarWidth = '356px';

export const DashboardLayout = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #F8F9FB; 
`;

export const MainContent = styled.div`
  flex-grow: 1;
  padding: 34px;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 30px;

  @media(max-width: 1024px){
    grid-template-columns: repeat(2, 1fr);
  }
  @media(max-width: 640px){
    grid-template-columns: 1fr;
  }
`;

export const HighlightSection = styled.div`
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  overflow: hidden; /* esconde slides fora do container */
`;

export const HighlightHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const HighlightTitle = styled.h3`
  font-size: 28px;
  font-weight: 600;
  color: #333333;
`;

export const HighlightContentWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden; /* esconde os slides fora da view */
`;

export const HighlightContentSlider = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
`;

export const HighlightContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex-shrink: 0; /* impede o slide de encolher */
  width: 100%; /* cada slide ocupa toda a largura do container */
  gap: 20px;

  @media(max-width: 640px){
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HighlightIcon = styled.div`
  min-width: 60px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #EAF2FF;
  border-radius: 12px;
  flex-shrink: 0;
`;

export const HighlightDetails = styled.div`
  flex-grow: 1;
`;

export const HighlightItemTitle = styled.h4`
  font-size: 22px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 6px;
`;

export const HighlightDescription = styled.p`
  font-size: 17px;
  color: #566474;
  margin-bottom: 6px;
  line-height: 1.4;
`;

export const HighlightMeta = styled.div`
  font-size: 16px;
  color: #888888;
`;

export const ActionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media(max-width: 1024px){
    grid-template-columns: repeat(2, 1fr);
  }
  @media(max-width: 640px){
    grid-template-columns: 1fr;
  }
`;
